import i18n from '@/i18n'
import { loadLocaleMessages } from '@/i18n/loaders'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'
import moment from 'moment'
import 'moment/locale/zh-cn'

const STORAGE_KEY = 'app-locale'
const momentMap = { zh: 'zh-cn', en: 'en' }

export function getPreferredLocale() {
  const url = new URL(window.location.href)
  const qp = url.searchParams.get('lang')
  if (qp && (qp === 'zh' || qp === 'en')) return qp
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved && (saved === 'zh' || saved === 'en')) return saved
  return 'zh'
}

export async function setLocale(lang) {
  if (!lang || (lang !== 'zh' && lang !== 'en')) return
  const msgs = await loadLocaleMessages(lang)
  i18n.setLocaleMessage(lang, msgs || {})
  i18n.locale = lang
  ElementLocale.use(lang === 'zh' ? zhLocale : enLocale)
  moment.locale(momentMap[lang] || 'en')
  localStorage.setItem(STORAGE_KEY, lang)
}

export async function applyLocaleFromUrl() {
  const url = new URL(window.location.href)
  const qp = url.searchParams.get('lang')
  if (qp && (qp === 'zh' || qp === 'en')) {
    await setLocale(qp)
  } else {
    await setLocale(getPreferredLocale())
  }
}

export function currentLocale() {
  return i18n.locale
}
